import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {WindowService} from '../../services/window.service';
import {AbstractSigaleComponent} from '../abstract-sigale.component';

@Component({
	standalone: true,
	selector: 'documentation-api',
	templateUrl: './documentation-api.html',
	styleUrls: ['./documentation-api.scss'],
	imports: [
		CommonModule,
		TranslateModule
	]
})
export class DocumentationApi extends AbstractSigaleComponent {

	constructor(private windowService: WindowService) {
		super();
	}

	public ouvrirSwagger() {
		this.windowService.openWindowWithToken('/swagger-ui/index.html?configUrl=/ws/v3/api-docs/swagger-config', '_blank');
	}

	traductionFR(): any {
		return {
			"SIGALE_ANGULAR": {
				"COMPONENTS": {
					"API_DOCS": {
						"TITRE_API_DOCS": "Documentation de l'API",
						"API_DOCS_LINK": "Voir l'API avec Swagger"
					}
				}
			}
		};
	}


	traductionIT(): any {
		return {
			"SIGALE_ANGULAR": {
				"COMPONENTS": {
					"API_DOCS": {
						"TITRE_API_DOCS": "Documenti dell'API",
						"API_DOCS_LINK": "Consultare l'API con Swagger"
					}
				}
			}
		};
	}
}
